import React from 'react';
import { BaseComponent } from './BaseComponent.js';
import $ from 'jquery';

export class Login extends BaseComponent {
  constructor(props) {
    super(props);
    this.changeUsername = this.changeUsername.bind(this);
    this.changePassword = this.changePassword.bind(this);
    this.login = this.login.bind(this);

    this.state = { username: '', password: '', token: '', error: 0 };
  }

  login(e) {
    e.preventDefault();
    /*
    curl -v -H 'Origin: http://localhost:3000' -c cookie.txt -b cookie.txt --data '{"Action":"Login","UserName":"testuniweb","Password":"uw-1317"}' https://sparkjvm.com/login
    */

    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/login',
      data: JSON.stringify({
        Action: 'Login',
        UserName: this.state.username,
        Password: this.state.password,
      }),
      xhrFields: {
        withCredentials: true
      },
      success: (res, status, jqXHR) => {
        let token = jqXHR.getResponseHeader('x-session');
        if (token) {
          this.setState({ error: 0 });
          this.setState({ token: token });
          this.getStatus();
        } else {
          this.setState({ error: 1 });
        }
      },
      error: (httpReq, status, exception) => {
        this.setState({ error: 1 });
      },
    });
  }

  getStatus() {
    /*
    curl -H 'Origin: http://localhost:3000' -H 'x-session: 5m1Sv+URCDpQS963jvQPh+j1HfI5J9NMAAAAAFr0AjFgoyrtZdmII9k6ijR1' -c cookie.txt -b cookie.txt --data '{"Action":"GetStatus"}' https://sparkjvm.com/login
    */
    $.ajax({
      method: 'POST',
      url: 'https://sparkjvm.com/login',
      headers: {
        'x-session': this.state.token,
      },
      xhrFields: {
        withCredentials: true
      },
      data: JSON.stringify({
        Action: 'GetStatus',
      }),
      dataType: 'JSON',
      success: (res, status, jqXHR) => {
        if (res.LoggedIn) {
          document.cookie = 'unithings_token=' + this.state.token + ";path=/";
          document.cookie = 'unithings_user=' + res.User.Name + ";path=/";
          window.location.href = '/';
        } else {
          this.setState({ error: 2 });
        }
      },
      error: (httpReq, status, exception) => {
      },
    });
  }

  changeUsername(e) {
    this.setState({ username: e.target.value });
  }

  changePassword(e) {
    this.setState({ password: e.target.value });
  }

  renderErrors() {
    if (this.state.error === 1) {
      return (
        <div className="login__form__row login__form__row--error">
          Username o password errati.
        </div>
      );
    } else if (this.state.error === 2) {
      return (
        <div className="login__form__row login__form__row--error">
          Errore generico
        </div>
      );
    }
    return '';
  }

  render() {
    return (
      <div className="login">
        <form className="login__form" onSubmit={ this.login }>
          <div className="login__logo">
            <img className="login__logo__img" src={require('../images/unithings.png')} alt="Unithings"/>
          </div>
          <div className="login__form__row">
            <input type="text" name="username" value={ this.state.username } onChange={ this.changeUsername } placeholder="Username" />
          </div>
          <div className="login__form__row">
            <input type="password" name="password" value={ this.state.password } onChange={ this.changePassword } placeholder="Password" />
          </div>
          <div className="login__form__row login__form__row--last">
            <button>Login</button>
          </div>
          { this.renderErrors() }
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Login.js